import React from 'react';

const Maintainance = () => {
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h1>Maintenance Mode</h1>
      <p>The site is currently under maintenance. Please check back later.</p>
    </div>
  );
};

export default Maintainance;